<div class="owner-dashboard-page entity-config-page container-fluid">
  <blocking-loader-overlay
    :show="loading_dashboard"
    :message="page_loading_message"
    :detail="page_loading_detail"
  />
  <div class="owner-dashboard-shell mx-auto">
    <section class="owner-dashboard-hero shadow">
      <div class="owner-dashboard-kicker">
        {{ greeting.day_label }} <span class="owner-dashboard-kicker-dot">·</span> {{ greeting.date_label }}
      </div>
      <h1 class="owner-dashboard-title mb-0">{{ greeting.title }}</h1>
      <div class="owner-dashboard-summary">
        <template v-for="(segment, index) in greeting.summary_segments" :key="`${segment.text}-${index}`">
          <strong v-if="segment.strong">{{ segment.text }}</strong>
          <span v-else>{{ segment.text }}</span>
        </template>
      </div>
    </section>

    <section class="row g-3 owner-dashboard-metrics">
      <div v-for="(metric, index) in metrics" :key="metric.label" class="col-12 col-sm-6 col-xl-3">
        <article class="owner-dashboard-metric-card shadow" :class="{ 'is-accented': index === 0 }">
          <div class="owner-dashboard-metric-label fw-bold">{{ metric.label }}</div>
          <div class="owner-dashboard-metric-value">{{ metric.value }}</div>
          <div class="owner-dashboard-metric-detail">{{ metric.detail }}</div>
        </article>
      </div>
    </section>

    <section class="row g-4 align-items-start owner-dashboard-content">
      <div class="col-12 col-xl-8">
        <div class="owner-dashboard-section-head">
          <div>
            <h2 class="owner-dashboard-section-title mb-1">{{ queue_title }}</h2>
            <div class="owner-dashboard-section-subtitle">{{ queue_subtitle }}</div>
          </div>
          <router-link :to="{ name: 'OwnerQueue' }" class="owner-dashboard-view-all">
            View all {{ queue_count_label }} <span aria-hidden="true">→</span>
          </router-link>
        </div>

        <div class="owner-dashboard-queue">
          <article
            v-for="item in queue_items"
            :key="item.case_code"
            class="owner-dashboard-queue-card case-clickable-card"
            @click="go_to_case_detail(item.case_code)"
          >
            <div class="owner-dashboard-queue-body">
              <div>
                <span class="owner-dashboard-chip" :class="item.chip_badge_class">
                  {{ item.chip }}
                </span>
                <div class="owner-dashboard-queue-title">{{ item.title }}</div>
                <div class="owner-dashboard-queue-meta">{{ item.meta }}</div>
              </div>
              <div class="owner-dashboard-queue-action-wrap">
                <button
                  type="button"
                  class="owner-dashboard-queue-action"
                  :class="item.action_class"
                  @click.stop="go_to_case_detail(item.case_code)"
                >
                  {{ item.action_label }} <span aria-hidden="true">→</span>
                </button>
              </div>
            </div>
          </article>
        </div>
      </div>

      <div class="col-12 col-xl-4">
        <aside class="owner-dashboard-activity">
          <div class="owner-dashboard-activity-head">
            <h2 class="owner-dashboard-activity-title mb-0">Activity</h2>
            <div class="owner-dashboard-activity-window">Last 24h</div>
          </div>

          <div class="owner-dashboard-activity-list">
            <article
              v-for="(item, index) in activity_items"
              :key="`${item.meta}-${index}`"
              class="owner-dashboard-activity-item"
              :class="{ 'is-last': index === activity_items.length - 1 }"
            >
              <span class="owner-dashboard-activity-dot" :class="item.dot_class"></span>
              <div class="min-w-0">
                <div class="owner-dashboard-activity-meta">{{ item.meta }}</div>
                <div class="owner-dashboard-activity-text">{{ item.text }}</div>
              </div>
            </article>
            <div v-if="!activity_items.length" class="owner-dashboard-empty-state">
              No recent activity yet.
            </div>
          </div>
        </aside>
      </div>
    </section>
  </div>
</div>
